export default __webpack_public_path__ + "images/DI.18ddf01.png";